import { ref, computed } from '@vue/composition-api';

const VIVAT_PERMISSION = 'VIVAT_PERMISSION';
const permissions = ref([]);
const isLoaded = ref(false);

export default function usePermission() {
  function loadPermission() {
    const permissionsJSON = localStorage.getItem(VIVAT_PERMISSION);
    if (permissionsJSON) {
      isLoaded.value = true;
      permissions.value = JSON.parse(permissionsJSON);
    } else {
      permissions.value = [];
    }
  }

  function hasPermission(name: string) {
    return computed(() => (permissions.value.map((str: string) => str.toLowerCase())).indexOf(name) !== -1).value;
  }

  return {
    loadPermission,
    hasPermission,
    isLoaded,
  };
}
